<template>
  <div
    class="flex items-stretch max-w-1xl w-full rounded-[14px] overflow-hidden border transition-all duration-200"
    :class="[
      focused ? 'shadow-[0_0_0_4px]' : '',
      isLight
        ? 'bg-white border-[#d0ede8] focus-within:border-[#1a9b8a] focus-within:shadow-[#1a9b8a]/20'
        : 'bg-white/6 border-white/10 focus-within:border-[#1a9b8a]/50 focus-within:shadow-[#1a9b8a]/10',
    ]"
  >
    <!-- Search icon -->
    <div class="flex items-center pl-5 pr-4 flex-shrink-0" :class="isLight ? 'text-[#1a9b8a]' : 'text-[#a8d5cc]'">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>
    </div>

    <!-- Input -->
    <input
      v-model="searchTerm"
      type="text"
      :placeholder="$t('search.placeholder')"
      class="flex-1 bg-transparent border-none outline-none py-[17px] text-[15px]"
      :class="[
        isLight
          ? 'text-[#0f1f1c] placeholder:text-[#6b8f89]/60'
          : 'text-white placeholder:text-[#a8d5cc]/40',
      ]"
      @focus="focused = true"
      @blur="focused = false"
      @keyup.enter="searchEvent"
    />

    <!-- Divider -->
    <div class="my-[13px] w-px flex-shrink-0" :class="isLight ? 'bg-[#d0ede8]' : 'bg-white/10'"></div>

    <!-- Location -->
    <button
      type="button"
      class="hidden sm:flex items-center gap-2 px-4 text-sm flex-shrink-0 transition-colors duration-200"
      :class="isLight ? 'text-[#0d6b5e] hover:text-[#0f1f1c]' : 'text-[#a8d5cc] hover:text-white'"
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
      <!-- {{ $t('search.location') }} -->
    </button>

    <!-- Search button -->
    <button
      @click="searchEvent"
      class="m-[7px] px-6 rounded-[9px] font-display text-sm font-bold text-white transition-colors duration-200 whitespace-nowrap"
      :class="isLight ? 'bg-[#1a9b8a] hover:bg-[#0d6b5e]' : 'bg-[#1a9b8a] hover:bg-[#0d6b5e]'"
    >
      {{ $t('search.button') }}
    </button>
  </div>
</template>

<script>
export default {
  name: "SearchComponent",
  props: { isLight: Boolean },
  data() {
    return { searchTerm: "", focused: false };
  },
  methods: {
    searchEvent() {
      const term = this.searchTerm.trim();
      if (!term) return;
      this.$router.push({ name: "search-results", query: { event: term } });
    },
  },
};
</script>